// src/components/AdminRoute.jsx
// Protected route component that checks admin status before rendering

import React from "react";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #3498db',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto',
            marginBottom: '20px'
          }} />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // If not logged in, show access denied
  if (!user) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          backgroundColor: '#fff',
          padding: '40px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          maxWidth: '400px',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#333', marginBottom: '20px' }}>Authentication Required</h2>
          <p style={{ color: '#666', marginBottom: '30px' }}>
            You must be logged in to access the admin panel.
          </p>
          <a 
            href="/" 
            style={{
              display: 'inline-block',
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: '4px',
              transition: 'background-color 0.3s'
            }}
          >
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  // If logged in but not admin, show access denied
  if (!isAdmin) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          backgroundColor: '#fff',
          padding: '40px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          maxWidth: '400px',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#e74c3c', marginBottom: '20px' }}>Access Denied</h2>
          <p style={{ color: '#666', marginBottom: '30px' }}>
            You do not have admin privileges. This area is restricted to administrators only.
          </p>
          <a 
            href="/" 
            style={{
              display: 'inline-block',
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: '4px',
              transition: 'background-color 0.3s'
            }}
          >
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  // User is authenticated and is admin, render children
  return children;
}
